import React from 'react';
import SelectAndOptions from '../../SelectAndOptions';

export default function Row({
  setJanItem,
  setFevItem,
  setMarItem,
  setAbrItem,
  setMaiItem,
  setJunItem,
  setJulItem,
  setAgoItem,
  setSetItem,
  setOutItem,
  setNovItem,
  setDezItem,
  totalMonthsRow,
  optionsArray,
}) {
  return (
    <tr>
      <td>
        <SelectAndOptions title="" id="secondItem" optionsArray={optionsArray} widthPercentage="200px" />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setJanItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setFevItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setMarItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setAbrItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setMaiItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setJunItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setJulItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setAgoItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setSetItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setOutItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setNovItem(value);
          }}
        />
      </td>
      <td>
        <input
          type="text"
          className="UnitValueInput"
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace('.', '');
            value = value.replace(',', '.');
            setDezItem(value);
          }}
        />
      </td>
      <td>
        <p>{totalMonthsRow.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
      </td>
    </tr>
  );
}
